import { useEffect, useRef, useState } from "react"
import { soul } from "lib/soul"
import { ApiBundle, PaygateProps } from "../paygate"
import { Hero } from "./hero"
import { Photos } from "./photos"
import { Plans } from "./plans"
import bgPlans from "./assets/bg-plans.svg"
import { Benefits } from "./benefits"
import { Reviews } from "./reviews"
import { usePaygate2ScreenSharedState } from "./shared-state"

type Props = Omit<PaygateProps, "type" | "onSuccess"> & {
  goNext: () => void
}

export const planNames = [
  "pure-web_weekly_stripe_us",
  "pure-web_monthly_stripe_us",
  "pure-web_year_stripe_us",
]

export function Paygate2ScreenPaywall(props: Props) {
  const [plansFetching, setPlansFetching] = useState(false)
  const { isActive, surveyId, goNext } = props
  const {
    isCountdownActive,
    startCountdown,
    formattedCountdown,
    setSelectedPlan,
    selectedPlan,
    setApiPlans,
    apiPlans,
    originalPrices,
  } = usePaygate2ScreenSharedState(surveyId, planNames[1])
  const [plans, setPlans] = useState<ApiBundle[]>(apiPlans || [])
  const scrollRef = useRef<HTMLDivElement | null>(null)

  const onContinueClick = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setPlansFetching(true)
        const { results } = await soul.purchases.getBundles(
          planNames,
          undefined,
          ["stripe"],
        )

        setPlans(results)
        setApiPlans(results)
      } catch (e: any) {
        const alias =
          e?.response?.body?.error?.alias || "failed to fetch api bundles"
        const status = e?.status
        props.onPaymentError(alias, status)
      } finally {
        setPlansFetching(false)
      }
    }

    if (!apiPlans.length) {
      fetchData()
    }
  }, [])

  useEffect(() => {
    if (isActive && !isCountdownActive) {
      startCountdown()
    }
  }, [isActive, isCountdownActive])

  return (
    <div className="w-full">
      <Hero formattedCountdown={formattedCountdown} onClick={onContinueClick} />
      <Photos onClick={onContinueClick} />
      <div
        className="bg-[length:100%_100%] pt-16 pb-10"
        style={{ backgroundImage: `url(${bgPlans})` }}
        ref={scrollRef}
      >
        <Plans
          plans={plans}
          loading={plansFetching}
          planNames={planNames}
          selectedPlan={planNames.indexOf(selectedPlan) as 0 | 1 | 2}
          selectPlan={(idx: 0 | 1 | 2) => setSelectedPlan(planNames[idx])}
          onContinueClick={goNext}
          theme="dark"
          originalPrices={originalPrices}
        />
      </div>
      <Benefits />
      <Reviews />
      <div className="bg-violet-200 pb-[60px]">
        <Plans
          plans={plans}
          loading={plansFetching}
          planNames={planNames}
          selectedPlan={planNames.indexOf(selectedPlan) as 0 | 1 | 2}
          selectPlan={(idx: 0 | 1 | 2) => setSelectedPlan(planNames[idx])}
          onContinueClick={goNext}
          theme="light"
          originalPrices={originalPrices}
        />
      </div>
    </div>
  )
}
